import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoalibaugcab() {



const cardData = {
  keyword: "Mumbai to Alibaug Cab",

headingDescription:
  "Omshree Cab offers safe and comfortable Mumbai to Alibaug cab services for travelers seeking a relaxing beach getaway or a weekend retreat from the city. Whether you are planning a family vacation, a romantic trip, a corporate outing, or a group tour, our cab service ensures a smooth and hassle-free journey with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet features air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance and coastal routes, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Alibaug cab services.",

topPlaces: [
  {
    title: "Alibaug Beach",
    description:
      "Alibaug Beach is a popular destination known for its clean sands, serene ambiance, and beautiful sunset views. Visitors can enjoy leisurely walks, photography, and local snacks sold by vendors. Traveling by cab ensures a comfortable journey from Mumbai, allowing tourists to relax and spend ample time exploring the beach without worrying about local transportation or parking."
  },
  {
    title: "Kolaba Fort",
    description:
      "Kolaba Fort is a historic fort located on the coast, accessible during low tide via a short walk from Alibaug Beach. The fort features old fortifications, temples, and panoramic views of the Arabian Sea. A cab ride provides convenient access, allowing visitors to combine the beach and fort visits in a seamless day trip while enjoying the scenic coastal route."
  },
  {
    title: "Varsoli Beach",
    description:
      "Varsoli Beach is a quiet and less-crowded beach near Alibaug, ideal for families, couples, and those seeking tranquility. Visitors can enjoy swimming, sand play, and peaceful walks along the shore. Using a cab ensures easy access to the beach and flexibility in timing, making it simple to combine with other nearby attractions."
  },
  {
    title: "Kihim Beach",
    description:
      "Kihim Beach is known for its lush greenery, clean sands, and birdwatching opportunities. It is perfect for nature lovers and photography enthusiasts. A cab service provides comfortable travel from Mumbai, allowing visitors to explore the beach and nearby attractions without the stress of local commuting."
  },
  {
    title: "Nagaon Beach",
    description:
      "Nagaon Beach is famous for water sports like jet skiing, banana boat rides, and parasailing. Visitors can enjoy adventure activities, relax by the sea, and savor local food at nearby stalls. Traveling by cab ensures safe and convenient access, giving visitors flexibility in planning their day while enjoying the coastal experience."
  },
  {
    title: "Akshi Beach",
    description:
      "Akshi Beach is a serene and less-visited beach near Alibaug, ideal for photography, peaceful walks, and family picnics. A cab ride allows travelers to reach the beach comfortably and spend time exploring its tranquil environment along with other Alibaug attractions."
  },
  {
    title: "Kankeshwar Temple",
    description:
      "Kankeshwar Temple is a hilltop Shiva temple near Alibaug, offering panoramic views of the surrounding landscape. Visitors can combine a spiritual visit with a short trek to enjoy scenic beauty. A cab service ensures easy access to the temple base, making it convenient to plan the visit alongside beaches and forts."
  },
  {
    title: "Alibaug Market",
    description:
      "Alibaug Market is a lively area offering local handicrafts, souvenirs, snacks, and shopping experiences. Visitors can explore local culture, taste regional delicacies, and buy unique items. Traveling by cab allows convenient access, making it easy to include the market in a day’s sightseeing itinerary."
  },
  {
    title: "Murud-Janjira Fort",
    description:
      "Murud-Janjira Fort, located a short drive from Alibaug, is a majestic sea fort known for its history, architecture, and strategic location. Visitors can take a boat ride to explore the fort and enjoy stunning coastal views. A cab ride provides safe and comfortable transport, allowing travelers to include the fort visit without worrying about navigation or public transport."
  },
  {
    title: "Revdanda Beach & Fort",
    description:
      "Revdanda Beach and Fort is a serene coastal destination with historical significance, featuring ruins of an old fort and peaceful beach stretches. Visitors can enjoy photography, nature walks, and a quiet retreat. Traveling by cab ensures convenient access and flexibility in planning the visit along with other Alibaug attractions."
  }
],




services: [
{
name: "Mumbai to Alibaug Cab",
description: "Mumbai to Alibaug cab service provides a comfortable and reliable travel option for tourists and travelers visiting the beautiful coastal destination of Alibaug. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles that ensure a smooth journey along the scenic Mumbai–Alibaug highway routes. Professional drivers with excellent route knowledge guarantee safe and timely travel. Pickup is available from homes, hotels, offices, railway stations, and Mumbai airport terminals. The service is ideal for weekend beach trips, family vacations, corporate outings, and sightseeing tours. Spacious seating and air-conditioned interiors provide relaxed travel throughout the journey. Flexible one-way and round-trip options make planning convenient for travelers. Transparent pricing and no hidden charges ensure a trusted cab booking experience."
},
{
name: "Mumbai to Alibaug Taxi",
description: "Mumbai to Alibaug taxi service offers convenient and affordable transportation for travelers planning a coastal getaway to Alibaug. Comfortable AC vehicles ensure a pleasant road journey through beautiful coastal landscapes and highways. Our experienced drivers are familiar with the fastest and safest routes connecting Mumbai and Alibaug. Pickup services are available across Mumbai including homes, hotels, offices, and airport terminals. The service is perfect for couples, families, tourists, and business travelers. Spacious seating and clean interiors provide a relaxed and enjoyable journey. Flexible travel scheduling allows passengers to choose their preferred departure time. Reliable taxi service ensures safe, punctual, and stress-free travel."
},
{
name: "Mumbai to Alibaug Cab Service",
description: "Mumbai to Alibaug cab service provides a dependable travel solution for tourists and travelers visiting the popular beach destination of Alibaug. Our AC vehicles are maintained for smooth long-distance travel and passenger comfort. Experienced chauffeurs ensure safe highway driving and timely arrivals. Pickup is available from any location in Mumbai including hotels, residential areas, offices, and airports. This service is ideal for beach holidays, weekend getaways, and sightseeing trips. Comfortable seating and air-conditioned vehicles make the journey relaxing. Flexible booking options allow easy planning of trips. Transparent pricing ensures travelers enjoy reliable travel without hidden charges."
},
{
name: "Mumbai to Alibaug Taxi Service",
description: "Mumbai to Alibaug taxi service is designed to provide convenient intercity travel between Mumbai and the scenic coastal town of Alibaug. Our fleet includes clean and comfortable AC vehicles that ensure relaxed travel for passengers. Skilled drivers ensure safe driving along coastal and highway routes. Pickup services are available across Mumbai including hotels, homes, offices, and airport terminals. Ideal for weekend vacations, beach tourism, and family trips. Spacious seating ensures passengers travel comfortably during the journey. Flexible booking options help travelers schedule trips easily. Affordable pricing and professional service guarantee a reliable travel experience."
},
{
name: "Cab from Mumbai to Alibaug",
description: "Cab from Mumbai to Alibaug offers a private and comfortable travel option for tourists visiting this popular beach destination. Our AC vehicles ensure smooth highway journeys and pleasant travel experiences. Professional drivers provide safe and punctual travel across coastal routes. Pickup is available from homes, hotels, offices, and airports across Mumbai. Ideal for beach vacations, family trips, and group outings. Spacious interiors ensure passengers travel comfortably even on longer journeys. Flexible travel timing helps passengers plan trips easily. Reliable cab service ensures a stress-free journey from Mumbai to Alibaug."
},
{
name: "Taxi from Mumbai to Alibaug",
description: "Taxi from Mumbai to Alibaug offers reliable transportation for travelers planning beach trips or weekend holidays. Our well-maintained AC vehicles ensure comfortable travel across scenic coastal routes. Experienced drivers guarantee safe driving and timely arrivals. Pickup is available from any location in Mumbai including airport terminals. Ideal for couples, families, tourists, and small groups. Clean interiors and spacious seating ensure a pleasant journey. Flexible travel options make it easy to schedule trips anytime. Professional taxi service ensures convenient and safe travel."
},
{
name: "Mumbai to Alibaug Cab Booking",
description: "Mumbai to Alibaug cab booking allows travelers to reserve vehicles easily for comfortable coastal travel. Our online and phone booking options provide instant confirmation and convenient scheduling. AC sedans and SUVs ensure relaxed long-distance travel experiences. Professional drivers ensure safe highway driving and timely pickup. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting beaches and sightseeing locations in Alibaug. Flexible one-way and round-trip booking options are available. Reliable booking service ensures smooth and hassle-free travel."
},
{
name: "Mumbai to Alibaug Taxi Booking Online",
description: "Mumbai to Alibaug taxi booking online provides quick and easy reservation for travelers planning beach trips. Instant booking confirmation ensures travelers can plan their journeys without delays. Comfortable AC vehicles guarantee smooth travel through coastal highways. Experienced drivers provide safe and professional driving services. Pickup is available from hotels, homes, offices, and Mumbai airport terminals. Ideal for weekend trips, family vacations, and sightseeing tours. Flexible travel timing allows convenient departure scheduling. Reliable taxi booking system ensures a smooth travel experience."
},
{
name: "Mumbai to Alibaug Cab Price",
description: "Mumbai to Alibaug cab price offers affordable travel options for passengers visiting this popular beach destination. Transparent pricing ensures customers clearly understand travel costs before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for various travel needs. Comfortable seating and AC interiors ensure relaxed travel throughout the journey. Professional drivers guarantee safe and punctual travel experiences. Pickup services are available across Mumbai including airport terminals. Flexible trip options allow passengers to choose one-way or round-trip travel. Budget-friendly fares ensure convenient travel without hidden charges."
},
{
name: "Mumbai to Alibaug Taxi Fare",
description: "Mumbai to Alibaug taxi fare is calculated using transparent per-kilometer pricing for a clear and affordable travel experience. Passengers can choose from multiple vehicle options depending on comfort and budget preferences. Our AC vehicles ensure smooth travel along coastal and highway routes. Experienced drivers guarantee safe driving and punctual arrivals. Pickup services are available across Mumbai including hotels, homes, offices, and airports. Ideal for tourists, families, and couples planning beach trips. Flexible travel options allow convenient trip scheduling. Reliable taxi fare system ensures transparent and stress-free booking."
},
{
name: "Mumbai to Alibaug One Way Cab",
description: "Mumbai to Alibaug one way cab service is ideal for travelers who need a drop service without paying return charges. This option helps reduce travel costs while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for coastal journeys. Professional drivers ensure safe and smooth highway driving. Pickup is available from homes, hotels, offices, and Mumbai airport terminals. Perfect for tourists visiting Alibaug beaches or planning short trips. Flexible travel scheduling ensures convenient departures. Reliable one-way cab service ensures affordable and comfortable travel."
},
{
name: "Mumbai to Alibaug Round Trip Taxi",
description: "Mumbai to Alibaug round trip taxi service offers complete travel convenience for passengers planning return journeys. Flexible return timing allows tourists to enjoy beach sightseeing and relaxation without rush. Comfortable AC vehicles ensure relaxed long-distance travel experiences. Professional drivers remain available for return travel according to the passenger schedule. Pickup services are available across Mumbai including hotels, homes, and airport terminals. Ideal for family vacations, corporate trips, and weekend getaways. Spacious vehicles ensure comfortable travel for groups and families. Reliable round-trip taxi service ensures smooth travel planning."
}
],

tableData: [
["Mumbai to Alibaug Cab","Mumbai to Alibaug Taxi"],
["Mumbai to Alibaug Cab Service","Mumbai to Alibaug Taxi Service"],
["Cab from Mumbai to Alibaug","Taxi from Mumbai to Alibaug"],
["Mumbai to Alibaug Cab Booking","Mumbai to Alibaug Taxi Booking Online"],
["Mumbai to Alibaug Cab Price","Mumbai to Alibaug Taxi Fare"],
["Mumbai to Alibaug One Way Cab","Mumbai to Alibaug Round Trip Taxi"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Coastal Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the Mumbai to Alibaug coastal route. They are familiar with the fastest highways, ferry points, and scenic coastal roads, ensuring a safe, smooth, and relaxing journey to this popular beach destination."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs offers clear and transparent pricing for Mumbai to Alibaug cab services. All fares, toll charges, and trip packages are explained before booking so customers never face hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you are planning an early morning beach trip or a late-night return from Alibaug, Omshree Cabs provides round-the-clock cab booking and support for your convenience."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet consists of well-maintained, fully air-conditioned vehicles that are cleaned and sanitized before every trip. This ensures a comfortable and refreshing journey from Mumbai to Alibaug."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We provide flexible travel plans including one-way cabs, round trips, and same-day return packages. Travelers can customize their travel schedule and stops according to their trip plans."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, spacious SUVs like Ertiga and Innova, and premium vehicles suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Alibaug begins smoothly without any travel hassle."
  },
  {
    WhyChooseheading: "Reliable Beach Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Alibaug trips. Our punctual service, professional drivers, and comfortable vehicles make your beach travel relaxing and stress-free."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Alibaug by cab?", answer: "The distance from Mumbai to Alibaug is approximately 95 km and usually takes around 2–3 hours depending on traffic and route conditions." },
  { question: "Do you provide one-way Mumbai to Alibaug cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services from Mumbai to Alibaug." },
  { question: "Which vehicles are available for Mumbai to Alibaug travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort requirements." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Alibaug cab bookings." },
  { question: "Can we visit beaches and forts in Alibaug?", answer: "Yes, travelers can visit popular attractions like Alibaug Beach, Kolaba Fort, Nagaon Beach, and Kashid Beach during the trip." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for a comfortable journey." },
  { question: "Do you offer same-day return packages?", answer: "Yes, we offer convenient same-day return cab packages for Mumbai to Alibaug trips." },
  { question: "Can we stop for sightseeing during the trip?", answer: "Yes, passengers can request stops during the journey for sightseeing, meals, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday seasons when Alibaug is very popular." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akash Mehta",
    feedback:
      "Booked Omshree Cabs for a Mumbai to Alibaug beach trip. The driver was punctual and the car was very clean. The journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Our family trip to Alibaug with Omshree Cabs was excellent. On-time pickup, professional driver, and transparent pricing made the trip very pleasant.",
    rating: 5
  }
];























































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Alibaug Cab",
  "description": "Book Mumbai to Alibaug Cab with Omshree Cab for comfortable beach travel. Reliable taxi service from Mumbai to Alibaug with options for one-way or round trips. Affordable cab fares, easy online booking, and safe travel for your Alibaug trip.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2400"
  }
};





  return (
    <div>
      <Helmet>
  <title>Mumbai to Alibaug Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Alibaug Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Alibaug with one-way and round trip options. Affordable fares and easy online cab booking for your Alibaug trip." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoalibaugcab;